import axios from "axios";
import { google_api_key, crossOrigin } from "../../config";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return `${crossOrigin}/https://maps.googleapis.com/maps/api`;
};

export const secondURL = () => {
  return APIHost() + ":3006/general";
};

export const loadGooglePlaceAutocomplete = (value) => {
  const url = `${baseURL()}/place/autocomplete/json?input=${value}&key=${google_api_key}&region=my`;
  return axios.get(url);
};

export const lololAutoComplete = (value) => {
  let params = {
    value: value,
  };
  const url = `${secondURL()}/mapSearchAutocomplete/`;
  return axios.post(url, params);
};
